/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from 'react'
import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { FaCheckCircle, FaRegTimesCircle, FaFireAlt } from 'react-icons/fa'
import StripeCheckout from 'react-stripe-checkout'
import config from '../../../config'
import ConfigBilling from './config'
import MavCircleCheckBox from '../../../components/common/MavCircleCheckBox'

/** Stripe publishable key */
const STRIPE_PUBLISHABLE_KEY = config.STRIPE_PUBLIC_KEY

const { STRIPE_V2 } = ConfigBilling

const useStyles = makeStyles(() => ({
  activeStep: {
    color: '#27A9E0 !important',
  },
  icon: {
    color: 'red !important',
  },
  fixedHeight: {
    height: 240,
  },
}))

const handlePriceDemo = (type: string): void => {
  if (type === 'AutoPilot') {
    window.location.href = 'https://maverickapp.io/pricing/#demo'
  }
}

const MemberShip: FC<any> = props => {
  const classes = useStyles()
  const { subscribeToProductPlan, billingTerms, setBillingTerms } = props
  const toggleChecked = (type: string): void => {
    setBillingTerms(type)
  }

  return (
    <div style={{ display: 'contents' }}>
      <div style={{ textAlign: 'center', height: '6em' }}>
        <div className="membership-select">
          <MavCircleCheckBox
            title="Annual Subscription"
            status={billingTerms === 'Yearly'}
            handleClick={(): void => toggleChecked('Yearly')}
          />
          <MavCircleCheckBox
            title="Monthly Subscription"
            status={billingTerms === 'Monthly'}
            handleClick={(): void => toggleChecked('Monthly')}
          />
        </div>
      </div>
      <div className="row" />
      <div className="membership row">
        {STRIPE_V2[billingTerms].map(column => (
          <div className="col-md-4">
            <div className={`plan ${column.primaryHeader === 'AutoPilot' ? ' featured' : ''}`}>
              {column.primaryHeader === 'Pro' && (
                <div className="popular">
                  <div className="popular_text">Most Popular</div>
                </div>
              )}
              <div className="title-section">
                <h3 className="plan-title">{column.primaryHeader}</h3>
                <p className="plan-desc">
                  {column.primaryHeader === 'AutoPilot'
                    ? 'Let us run MaverickApp for you!'
                    : 'Feed your need for speed'}
                </p>
              </div>
              <div className="plan-cost">
                <p className="plan-price">
                  <span>$</span>
                  {column.price}
                </p>
                <p className="desc">{column.stripeDescription}</p>
              </div>
              {column.primaryHeader === 'Lite' && (
                <ul className="plan-features">
                  <li>
                    <FaCheckCircle className="check_icon" />
                    {column.importedLeads}
                  </li>
                  <li>
                    <FaCheckCircle className="check_icon" />
                    {`${column.templates} pre-built missions - Fully customizable`}
                  </li>
                  <li>
                    <FaCheckCircle className="check_icon" />
                    Unlimited sends
                  </li>
                  <li>
                    <FaCheckCircle className="check_icon" />
                    Access to our Success Wingman™ Team
                  </li>
                  <li>
                    <FaCheckCircle className="check_icon" />
                    Onboarding
                  </li>
                  <li>
                    <FaRegTimesCircle />
                    {column.templateAssist}
                  </li>
                  <li>
                    <FaRegTimesCircle />
                    RECON™ - Up to 0 contacts researched, and delivered to you – Monthly
                  </li>
                </ul>
              )}
              {column.primaryHeader === 'Pro' && (
                <ul className="plan-features">
                  <li>
                    <FaCheckCircle className="check_icon" />
                    {column.importedLeads}
                  </li>
                  <li>
                    <FaCheckCircle className="check_icon" />
                    {`${column.templates} pre-built missions - Fully customizable`}
                  </li>
                  <li>
                    <FaCheckCircle className="check_icon" />
                    Unlimited sends
                  </li>
                  <li>
                    <FaCheckCircle className="check_icon" />
                    Dedicated Success Wingman™
                  </li>
                  <li>
                    <FaCheckCircle className="check_icon" />
                    Pro Onboarding
                  </li>
                  <li>
                    <FaCheckCircle className="check_icon" />
                    RECON™ - Up to 400 contacts researched, and delivered to you – Monthly
                  </li>
                  <li>
                    <FaCheckCircle className="check_icon" />
                    {column.templateAssist}
                  </li>
                </ul>
              )}
              {column.primaryHeader === 'AutoPilot' && (
                <ul className="plan-features">
                  <li>
                    <FaFireAlt />
                    We deliver the conversations to you!
                  </li>
                  <li>
                    <FaCheckCircle className="check_icon" />
                    {column.importedLeads}
                  </li>
                  <li>
                    <FaCheckCircle className="check_icon" />
                    RECON™ - Up to 400 contacts researched, and delivered to you – Monthly
                  </li>
                  <li>
                    <FaCheckCircle className="check_icon" />
                    Unlimited sends
                  </li>
                  <li>
                    <FaCheckCircle className="check_icon" />
                    Managed by a MaverickApp Expert
                  </li>
                  <li>
                    <FaCheckCircle className="check_icon" />
                    Controlled by a Dedicated Business Development Expert
                  </li>
                  <li>
                    <FaCheckCircle className="check_icon" />
                    Monthly Consulting
                  </li>
                  <li>
                    <FaCheckCircle className="check_icon" />
                    Template Writing
                  </li>
                </ul>
              )}
              <div className="plan-select">
                <StripeCheckout
                  name="MaverickApp"
                  description={`Prospect Recon ${column.primaryHeader}`}
                  token={(token): Promise<void> => subscribeToProductPlan(token, column.id)}
                  billingAddress
                  zipCode
                  panelLabel="Subscribe"
                  stripeKey={STRIPE_PUBLISHABLE_KEY}
                >
                  {/* <a href="foo.com">Select Plan</a> */}
                  <Button
                    className={classes[column.buttonVariant]}
                    onClick={(): void => handlePriceDemo(column.primaryHeader)}
                  >
                    {column.primaryHeader === 'AutoPilot' ? 'Learn More' : 'Take Flight'}
                  </Button>
                </StripeCheckout>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default MemberShip
